Object.defineProperty(exports, "__esModule", { value: true });
exports.wrapRootElement = require('./wrapRootElement').wrapRootElement;
//# sourceMappingURL=gatsby-browser.js.map